import React, { useState } from 'react'

import { usePet } from '../../modules'

import Modal from "../resusable/modal"

const ModifyQuantity = ({ toggle, visible, store, record, onPerform }) => {
    const [quantity, setQty] = useState()

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Quantity has been modified', ops('success'))
        
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('modifyQuantity', {
        item: record?.item?._id,
        store: store?._id,
        quantity
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Modifying quantity...' } })

    return (
        <Modal
            h="h-auto"
            w="w-1/4"
            title="Modify Quantity"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        How many { record?.item?.issuedIn }?
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-qty"
                        type="number"
                        onChange={ e => setQty(e.target.value)}
                        placeholder="100" />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={ execute } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default ModifyQuantity